"use client"

import { displayProductDetails, isNegotiationLimitReached } from "./Utils"

export default function QuotationResponses({ quoteRequests, loading, setActiveQuote, MAX_NEGOTIATIONS }) {
  if (loading) {
    return (
      <div className="loading">
        <div className="loading__spinner"></div>
        <p>Loading your quotations...</p>
      </div>
    )
  }

  if (quoteRequests.length === 0) {
    return (
      <div className="alert alert--info">
        <p>No quotations found. Request a quote to get started.</p>
      </div>
    )
  }

  const latestQuote = quoteRequests[0]

  return (
    <div className="quotation-responses">
      <div className="quotation-responses__header">
        <h3 className="quotation-responses__title">Your Quotation Responses</h3>
      </div>

      <div className="quotation-list">
        <div className="quotation-card">
          <div className="quotation-card__header">
            <div className="quotation-card__title-area">
              <h4 className="quotation-card__title">
                Quote Request - {latestQuote.category || "Cement"} - {latestQuote.brand}
              </h4>
              <p className="quotation-card__date">Submitted: {latestQuote.timestamp || latestQuote.submittedAt}</p>
            </div>
            <div
              className={`badge ${
                latestQuote.supplierReply
                  ? "badge--success"
                  : latestQuote.status === "completed"
                    ? "badge--success"
                    : latestQuote.status === "negotiating"
                      ? "badge--outline"
                      : "badge--secondary"
              }`}
            >
              {latestQuote.supplierReply
                ? "Responded"
                : latestQuote.status === "completed"
                  ? "Negotiation Complete"
                  : latestQuote.status === "negotiating"
                    ? "Negotiating"
                    : "Pending Response"}
            </div>
          </div>

          <div className="quotation-card__details">
            <div className="quotation-card__section">
              <h5 className="quotation-card__section-title">Request Details</h5>
              <ul className="quotation-card__list">
                {displayProductDetails(latestQuote)}
                <li>
                  <span className="quotation-card__label">Site Address:</span> {latestQuote.siteAddress}
                </li>
              </ul>
            </div>

            <div className="quotation-card__section">
              <h5 className="quotation-card__section-title">Contact Information</h5>
              <ul className="quotation-card__list">
                <li>
                  <span className="quotation-card__label">Name:</span> {latestQuote.contactInfo.name}
                </li>
                <li>
                  <span className="quotation-card__label">Phone:</span> {latestQuote.contactInfo.phone}
                </li>
                <li>
                  <span className="quotation-card__label">Company Name:</span> {latestQuote.companyName}
                </li>
              </ul>
            </div>
          </div>

          {latestQuote.supplierReply ? (
            <div className="supplier-response">
              <h4 className="supplier-response__title">Supplier's Response</h4>
              <div className="supplier-response__content">
                <div className="supplier-response__section">
                  <ul className="supplier-response__list">
                    <li>
                      <span className="supplier-response__label">Supplier Email:</span>{" "}
                      {latestQuote.supplierReply.supplierEmail}
                    </li>
                    <li>
                      <span className="supplier-response__label">
                        {latestQuote.category === "cement" || !latestQuote.category
                          ? `Price Per ${latestQuote.cementType === "bulker" ? "MT" : "Bag"}`
                          : latestQuote.category === "steel"
                            ? "Price Per Ton"
                            : "Price Per Unit"}
                        :
                      </span>{" "}
                      {latestQuote.supplierReply.pricePerBag || latestQuote.supplierReply.pricePerUnit}
                    </li>
                    <li>
                      <span className="supplier-response__label">Total Price:</span>
                      {latestQuote.supplierReply.totalPrice}
                    </li>
                     <div className="rate-disclaimer">
                <small>*Rates are subject to change as per company regularly.</small>
              </div>
                  </ul>
                </div>

                <div className="supplier-response__section">
                  <p className="supplier-response__message-label">Message from Supplier:</p>
                  <p className="supplier-response__message">{latestQuote.supplierReply.message}</p>
                </div>
              </div>

              <div className="supplier-response__actions">
                {isNegotiationLimitReached(latestQuote, MAX_NEGOTIATIONS) ? (
                  <div className="negotiation-limit-message">
                    <p>Negotiation limit reached (maximum {MAX_NEGOTIATIONS} negotiations).</p>
                    <p>If you want to negotiate further, please contact us directly:</p>
                    <div className="contact-info">
                      <p>Thank you for choosing us for your needs.</p>
                      <p>
                        Best regards,
                        <br />
                        Altrange
                        <br />
                        Contact: +91-9876980108
                      </p>
                    </div>
                  </div>
                ) : (
                  <button onClick={() => setActiveQuote(latestQuote)} className="button button--primary">
                    Negotiate
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div className="no-response">
              <p className="no-response__message">
                Supplier has not responded to your quotation request yet. Please check back later.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
